import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query oktellPing {
      oktell {
        phone
        success
        error
      }
    }
  `,
  config: {
    skip: (ownProps) => ownProps.skip,
    options: ({ username }) => ({
      errorPolicy: "none",
      fetchPolicy: "network-only",
    }),
  },
  propTypes: {
    skip: PropTypes.bool,
  },
  dataKey: "oktell",
  isLoaded: (data) => {
    return !!data.oktell;
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/oktellPing.js